module.exports = __webpack_public_path__ + "img/halloween-window-12.9f4a61d8.svg";